export default __webpack_public_path__ + "static/media/camera.ddb47c67.svg";